import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import { stringAvatar } from '@components/UserAvatar/helpers';

const UserAvatarInitials = ({
  name,
  initials,
  onClick,
  sx = {},
}: {
  name: string;
  initials?: string;
  onClick?: () => void;
  sx?: any;
}) => {
  const avatarProps = stringAvatar((name || '').toUpperCase());
  const displayInitials = initials !== undefined ? initials : avatarProps.children;

  return (
    <Avatar
      onClick={onClick}
      children={displayInitials || <PersonIcon />}
      sx={{ ...sx, ...avatarProps.sx }}
    />
  );
};

export default UserAvatarInitials;
